const imgLoad = async (img): Promise<boolean> => {
  return new Promise<boolean>(res => {
    const maxTimeout = setTimeout(() => {
      res(false);
    }, 4000);
    img.onload = () => {
      clearInterval(maxTimeout);
      res(true);
    };
    img.onerror = () => {
      clearInterval(maxTimeout);
      res(false);
    };
  });
};
export default async url => {
  if (!url) {
    return;
  }
  let img = new Image();
  img.src = url;
  const isLoad = await imgLoad(img);
  return img.width > 5;
};
